import { render } from "./ProjectsList.vue?vue&type=template&id=04c96c18&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"

import "./ProjectsList.vue?vue&type=style&index=0&id=04c96c18&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c96c18"]])

export default __exports__